<template>
	<div class="box-list-wrapper" :class="{ 'align-left': alignLeft, 'size-large': size === 'large' }">
		<main-box-item v-for="(item, index) in list" :key="`box_${index}`" :item="item" :type="type" :size="size" />
	</div>
</template>

<script>
import MainBoxItem from '@/views/main/components/MainBoxItem.vue'

export default {
	name: 'BoxList',
	components: {
		MainBoxItem,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		type: {
			type: String,
			default: '',
		},
		// 아이콘 크기: '' (기본, 메인 페이지) | 'large' (브랜드관)
		size: {
			type: String,
			default: '',
		},
		// true면 마지막 줄도 왼쪽부터 채운다. (기본은 양 끝 정렬: 메인 페이지)
		alignLeft: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style lang="scss" scoped>
.box-list-wrapper {
	margin-top: 15px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	row-gap: 10px;
	/* 왼쪽 정렬: 한 줄 6개(170px) 가득 찰 때 간격이 양 끝 정렬과 같도록 12px (1080 - 170*6) / 5 */
	&.align-left {
		justify-content: flex-start;
		column-gap: 12px;
		/* large(200px)는 한 줄 5개: (1080 - 200*5) / 4 = 20px */
		&.size-large {
			column-gap: 20px;
			row-gap: 16px;
		}
	}
	/* 전체 데이터 표시: 2줄 제한 제거 */
	img {
		max-width: 100%;
	}
}

/* 모바일: 화면 폭에 맞춰 두 칸 격자 */
html.is-mobile .box-list-wrapper {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px !important;
	margin-top: 14px;
}
</style>
